var exports = {
  "N": "x127c5a35--863cda--area-link",
};

module.exports = exports;
